import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe,
          CoverSection       } from '../../Components/UI/UI'

import {  newPosts } from "../../Data/Data";
import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ExporeTelAvivAndJerusalem.css"

class ExporeTelAvivAndJerusalem extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  


  render(){
    

     // get all posts 
    const  posts = [ ...newPosts ] ;

    // get video posts 
    const nonVidPosts = posts.filter((o , i )=>{
      return ( o.isVid === true  || o.forVidPage === true) && o.isDouble === false;
    })


    const concertSHtml = nonVidPosts.map( (o,i) => {
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
       const url = "/Posts/Videos/" + o.ctg  + '/' + o.id;
 
        return <VideoSliderItem  
                  key={i}
                  title={o.title}
                  desc={""}
                  img= {o.img}
                  link={url}
                  cssClass={cssClass}
                 />
    });

    return(
      <div className="inner-page align-center page-ExporeTelAvivAndJerusalem">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        <CoverSection desktopImg={'/posts/bank/page-videos/1.jpg'} mobileImg={'/posts/bank/telaviv8/M.jpg'} cssClass={'telaviv'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
            VIDEOS
            </HomeTitle>
            {/*<ResponsiveYouTubeIframe vidId={'FYtk8JMMZRE'} />*/}
            {/*<ResponsiveYouTubeIframe vidId={'ogEN7aRT0SM'} />*/}
            
            <ResponsiveYouTubeIframe vidId={'tgF0zMUYY2g'} />
            {/*<ResponsiveYouTubeIframe vidId={'FYtk8JMMZRE'} />*/}
            <div className="live-shows-wrapper">
              {concertSHtml}
             
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default ExporeTelAvivAndJerusalem


// WEBPACK FOOTER //
// ./src/Pages/ExporeTelAvivAndJerusalem/ExporeTelAvivAndJerusalem.js